import { render } from "./gsAiWindow.vue?vue&type=template&id=782ece20"
import script from "./gsAiWindow.vue?vue&type=script&lang=js"
export * from "./gsAiWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__